export const dateRangePickerTranslations = {
    en: {
        // Labels
        startDate: "Start Date",
        endDate: "End Date",
        to: "to",
    },
    mr: {
        // Labels
        startDate: "प्रारंभ तारीख",
        endDate: "समाप्ती तारीख",
        to: "ते",
    }
};
